<template>
	<div :class="['splash', { 'big-splash': oneBigSplash }]">
		<div
			v-for="(splash, index) in limitedSplashes"
			:index="'splash-' + index + splash.id"
			:class="['single-splash', { 'small-splash': ! splash.bigSplash }]"
		>
			<ximg
				v-if="splash.imageSource"
				:src="convertToCdnUrl(splash.imageSource)"
				:ariaLabel="splash.imageAlt"
				role="img"
			/>
			<template v-if="! splash.bigSplash">
				{{ splash.splashText }}
			</template>
		</div>
		<div v-if="sponsored" class="single-splash small-splash sponsored-splash">
			Sponsrad
		</div>
	</div>
</template>

<script>
import { convertToCdnUrl } from 'utils';

export default {
	props: {
		splashes: {
			type: Array,
			default: () => [],
			required: true,
		},
		limit: {
			type: Number,
			default: 2,
			required: false,
		},
		sponsored: {
			type: Boolean,
			default: false,
			required: false,
		}
	},
	computed: {
		limitedSplashes () {
			let splashArray = [];
			const loopLength = (Math.min(this.limit, this.splashes.length));
			for (let i = 0; i < loopLength; i++) {
				splashArray.push(this.splashes[i]);
			}
			return splashArray;
		},
		oneBigSplash () {
			return this.limit === 1 && this.limitedSplashes[0].bigSplash;
		},
	},
	methods: {
		convertToCdnUrl,
	},
};
</script>
